import type Switch from '@rio-cloud/rio-uikit/Switch';
import type { ComponentProps } from 'react';

import type { RfidCardUpdateType } from '@/api/schema';
import { t } from '@/lib/utils';

type ActiveCellProps = Omit<ComponentProps<typeof Switch>, 'onChange' | 'labelPosition'> & {
    card: RfidCardUpdateType;
};

export const ActiveCell = ({ card, ...props }: ActiveCellProps) => (
    <div className='display-flex gap-5'>
        <span
            className={`rioglyph text-size-h5 ${
                props.checked ? 'rioglyph-ok-sign text-color-success' : 'rioglyph-remove-sign text-color-dark'
            }`}
        />
        <span>{props.checked ? t('general.active') : t('general.inactive')}</span>
    </div>
);
